<header class="d-flex flex-wrap align-items-center justify-content-between py-3 mb-4 border-bottom">
<div class="logo-container col-md-3 mb-2 mb-md-0 d-flex align-items-center">
  <a href="https://www.chiroone.com/" target="_blank" rel="noopener noreferrer" class="d-inline-flex align-items-center text-decoration-none">
    <img src="../assets/Nav-CO-Logo-CMYK-NoGradient-1.svg" alt="Chiro One" class="logo-img" />
  </a>
</div>

</header>

<app-loading></app-loading>

<div class="center-div">
   <div class="breadcrumb-container">
    <app-breadcrumb></app-breadcrumb>
  </div> 
 
  <router-outlet></router-outlet>



